export default __webpack_public_path__ + "static/media/Curve3.a2479211.svg";